export default __webpack_public_path__ + "static/media/Standard_Chatered.fb0c4516.jpg";